<template>
    <b-modal id="comparacion" hide-footer title="Comparación" :size="comparacion.length>2  ? 'xl' : 'md' "
             v-model="modal">
        <div class="table-responsive">
            <table class="table table-borderless table-sm">
                <colgroup>
                    <col/>
                    <col v-for="item in comparacion" :key="item.id" :class="item.id===actual.id && 'bg-sa' "/>
                </colgroup>
                <tbody>
                <tr v-for="ll in labels" :key="ll.name">
                    <td>
                        <strong>{{ll.show ? ll.name : null}}</strong>
                    </td>
                    <td v-for="item in comparacion" :key="item.id" class="text-center">
                        <button class="btn btn-block btn-outline-warning" v-if="ll.dto===null"
                                :disabled="item.id===actual.id" v-on:click="enviar(item)">
                            Cambiar a este paquete
                        </button>
                        <template v-else>
                            <img
                                    :src="ll.dto ? ll.aux+item[ll.dto] : spiner"
                                    class="p-1"
                                    :alt="ll.name + item.id"
                                    v-if="ll.name==='imagen'"/>
                            <span v-else-if="ll.name==='Precio'" class="precio-syb">
                                {{item[ll.dto] | puntos}}
                            </span>
                            <span v-else-if="ll.name==='Paquete'" v-html="item[ll.dto]" class="text-left"></span>
                            <span v-else>
                                {{item[ll.dto]}}
                            </span>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>

<script>
    import constantes from "../constantes";

    export default {
        name: "comparacion",
        props: {
            comparacion: {
                type: Array
            },
            actual: {
                type: Object
            }
        },
        filters: {
            puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
        },
        data: () => ({
            labels: [
                {
                    name: "imagen",
                    dto: "dt4",
                    aux: process.env.VUE_APP_URL_API,
                    show: false,
                },
                {
                    name: "titulo",
                    dto: "dt2",
                    aux: null,
                    show: false,
                },
                {
                    name: "Año",
                    dto: "ndt9",
                    aux: null,
                    show: true,
                },
                {
                    name: "Precio",
                    dto: "ndt10",
                    aux: null,
                    show: true,
                },
                {
                    name: "Paquete",
                    dto: "dt1",
                    aux: null,
                    show: true,
                },
                {
                    name: "Boton",
                    dto: null,
                    aux: null,
                    show: false,
                },
            ],
            modal: false,
            spiner: require("../assets/images/default_paquete.jpg"),
        }),
        methods: {
            enviar: function (item) {
                this.modal = false;
                this.$emit('cambio', item);
            }
        }
    }
</script>

<style scoped>
    .bg-sa {
        background-color: #fef9ed;
    }

</style>
